import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  getHighProfileEngagements as getHighProfileEngagementsQuery,
  getLeader as getleaderQuery,
  getTeamsWonEngageByOfferingId as getTeamsWonEngageByOfferingIdMutation,
} from '../graphql/queries'

export const useLeader = () => {
  const client = useMemo(() => generateClient(), [])
  const getHighProfileEngagements = useCallback(
    async (offeringId, bidYear) => {
      return client.graphql({
        query: getHighProfileEngagementsQuery,
        variables: { offeringId, bidYear },
      })
    },
    [client],
  )

  const fetchLeader = useCallback(
    async (id) => {
      return client.graphql({
        query: getleaderQuery,
        variables: { id },
      })
    },
    [client],
  )

  const getTeamsWonEngageByOfferingId = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: getTeamsWonEngageByOfferingIdMutation,
        variables: { offeringId },
      })
    },
    [client],
  )

  return {
    getHighProfileEngagements,
    fetchLeader,
    getTeamsWonEngageByOfferingId,
  }
}
